// import ZoncuActivityDetail from '../activityOperateDetail'
import ZoncuActivity from './index.js';
import Microapp from '@/components/micro-app';
import history from '@/history';
import env from '@/env';
import MyJoinZongcuDetail from './detail.js';

export default [
  {
    path: '/',
    component: ZoncuActivity,
  },
  {
    path: '/detail/*',
    component: MyJoinZongcuDetail,
    // component: () => (
    //   <Microapp
    //     // http://mcbeta.jd.com/dist/pages/activeManageBlock/page?activityId=10593419
    //     url={env.MC_DOMAIN + '/unitiedMarketing'}
    //     name="activityManageZongcuDetail"
    //     data={{
    //       basename: '/activity-manage/myCreate/zongcuActivity/myJoin/detail',
    //       flag: 'myJoinCreate',
    //       goBackHDCenter,
    //     }}
    //   />
    // ),
  },
];

function goBackHDCenter() {
  history.replace('/activity-manage/myCreate/zongcuActivity/myJoin');
}
